import React, { useState } from "react";
import axios from "axios";

export default function AddCertifications() {
  const [Name, setName] = useState(null);
  const [IssuingOrganization, setIssuingOrganization] = useState(null);
  const [CredentialID, setCredentialID] = useState(null);
  const [CredentialURL, setCredentialURL] = useState(null);
  const [Date, setDate] = useState(null);

  function OnFormSubmit(e) {
    e.preventDefault();

    if (Name === null) {
      alert("Name is required");
      return false;
    }
    if (IssuingOrganization === null) {
      alert("IssuingOrganization is required");
      return false;
    }
    if (CredentialID === null) {
      alert("CredentialID is required");
      return false;
    }
    if (CredentialURL === null) {
      alert("CredentialURL is required");
      return false;
    }
    if (Date === null) {
      alert("Date is required");
      return false;
    }

    const newCertificate = {
      Name,
      IssuingOrganization,
      CredentialID,
      CredentialURL,
      Date,
    };

    axios
      .post(
        process.env.REACT_APP_BACKEND_URL + "/api/certificates/addcertificates",
        newCertificate
      )
      .then(() => {
        alert("Insert Success");
        window.location = "/admincertifications";
      })
      .catch((err) => {
        alert(err);
      });
  }

  return (
    <div>
      <form
        onSubmit={OnFormSubmit}
        style={{ border: "3px solid blue", padding: "15px" }}
      >
        <div class="form-group">
          <label>Name</label>
          <input
            type="text"
            class="form-control"
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </div>
        <div class="form-group">
          <label>Issuing Organization</label>
          <input
            type="text"
            class="form-control"
            onChange={(e) => {
              setIssuingOrganization(e.target.value);
            }}
          />
        </div>
        <div class="form-group">
          <label>CredentialID</label>

          <input
            type="text"
            class="form-control"
            onChange={(e) => {
              setCredentialID(e.target.value);
            }}
          />
        </div>

        <div class="form-group">
          <label>CredentialURL</label>
          <input
            type="text"
            class="form-control"
            onChange={(e) => {
              setCredentialURL(e.target.value);
            }}
          />
        </div>
        <div class="form-group">
          <label>Date</label>
          <input
            type="date"
            class="form-control"
            onChange={(e) => {
              setDate(e.target.value);
            }}
          />
        </div>

        <button type="submit" class="btn btn-primary">
          ADD
        </button>
      </form>
    </div>
  );
}
